module.exports = __webpack_public_path__ + "media/start.07bf19f7.mp3";